export default "__VITE_ASSET__c6124ac1__"